import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Margin from '../interfaces/Margin.ts'

import { useAuth } from './useAuth.tsx'
import { makeUrlMargins } from './connectionData.tsx'

interface FetchParams {
  since: string
  until: string
  withAdditionals?: boolean
}

const useMarginFetcher = () => {
  const [errorMargin, setErrorMargin] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const fetchMargins = async ({ since, until, withAdditionals = true }: FetchParams) => {
    setLoading(true)

    const params = new URLSearchParams({
      organizationId: userData?.organization?._id ?? '',
      fechaIni: new Date(since).toISOString(),
      fechaFin: new Date(until).toISOString(),
      withAdditionals: withAdditionals.toString(),
    })

    try {
      const apiUrl = makeUrlMargins(params)
      const data = await customFetch<Margin[]>(apiUrl)
      setErrorMargin(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      const myError = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorMargin(myError)

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorMargin, loading, fetchMargins }
}

export default useMarginFetcher
